/**
 * @format
 * @flow
 */

const postal_code = require('japan-postal-code');
const Moment = require('moment');
const DateJp = require('UltraDate.js');
DateJp.setDefaultLocale('ja');

export function addressFromPostalCode(postalcode) {
  return new Promise(function(resolve) {
    postal_code.get(postalcode, function(address) {
      console.log(address.prefecture); // => "東京都"
      console.log(address.city); // => "千代田区"
      console.log(address.area); // => "千代田"
      console.log(address.street); // => ""
      const addressObj = {
        prefecture: address.prefecture ? address.prefecture : '',
        city: address.city ? address.city : '',
        area: address.area ? address.area : '',
        street: address.street ? address.street : ''
      };
      resolve(addressObj);
    });
  });
}
export function parseDate(date) {
  let momentObj = Moment(date, 'YYYY-MM-DD');
  let year = momentObj.year();
  let month = momentObj.month() + 1;
  let day = momentObj.date();
  return { day, month, year };
}
export function isEmpty(obj: any) {
  return Object.getOwnPropertyNames(obj).length === 0;
}
export function validRange(startMoment, endMoment, sameIsValid) {
  console.log('TCL: validRange -> startMoment', startMoment, endMoment);
  if (Moment(startMoment).isSame(Moment(endMoment))) {
    if (!sameIsValid) {
      return 'equal';
    } else {
      return null;
    }
  }
  return Moment(startMoment).isBefore(Moment(endMoment)) ? 'lesser' : 'greater';
}
export function dateCompare(dateA) {
  let dueDate = new DateJp(dateA + '/23').format('yyyy/MM/dd');
  let currentDate = new DateJp().format('yyyy/MM/dd');
  return currentDate > dueDate;
}
